import { useState, useEffect } from 'react';
import AddReminderButton from './lead-journey/addNewReminderButton';
import { useGetReminder } from '../api/reminder/useGetReminder';

export default function ReminderComponent({leadID, owner}) {
  const [showTable, setShowTable] = useState(false); // Controls whether the table is shown
  const {lastReminder, allReminders, refetch} = useGetReminder({leadID})

  const handleReminderAdd = () =>{
    refetch();
  };
  // Close the modal
  const closeModal = () => {
    setShowTable(false);
  };

  return (  

    <div className="p-5 flexitems-start bg-white shadow-sm rounded-3xl w-1/2 ml-8">
      <div className="flex justify-between items-start mt-3 w-full border-b border-gray-300 pb-2 mr-5">
        <div className='flex justify-between items-start'>
          <img src="/icons/notifications_active.svg" className='mt-2 size-7'/>
          <h1 className="mb-1 ml-2 font-semibold text-3xl mt-1">Reminders</h1>
        </div>
        {owner && <AddReminderButton leadID={leadID} onReminderAdd = {handleReminderAdd}/>}
      </div>
      

      <div className="flex justify-between items-start mt-3">
      {/* Display Last Reminder */}
      {lastReminder?.reminder_at ? (
        <div className="mb-4 flex-1 mr-4">
          <div className='flex justify-between items-start'>
            <h2 className="text-lg font-small mb-2 text-gray-400">Upcoming Reminder:</h2>
            {/* View All Button */}
            <button
              onClick={() => setShowTable(true)}
              className="text-black underline hover:text-blue-800 focus:outline-none font-bold text-sm flex-shrink-0"
            >
              View All
            </button>
          </div>
          <div className='bg-yellow-100 rounded-3xl px-4 py-2 border-[1px] border-yellow-300 w-full'>
            <p className="text-gray-700 font-light"> {lastReminder.reminder_at}</p>
            <p className="text-gray-700 text-lg"><b>{lastReminder.reminder_title}</b></p>
            <p className="text-gray-700">{lastReminder.reminder_details}</p>
          </div>
        </div>
      ) : (
        <p className="text-gray-500 flex-1 mr-4">No reminders available.</p>
      )}
      
      </div>

      

      {/* Modal to display the table of all reminders */}
      {showTable && (
        <div className="fixed inset-0 z-[60] bg-gray-500 bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg shadow-lg w-3/4 md:w-1/2 h-3/4 overflow-auto">
            {/* <h2 className="text-lg font-medium mb-4">All Reminders:</h2> */}
            <div className="mb-4">
              <table className="min-w-full bg-white border border-gray-200">
                <thead>
                  <tr className="bg-gray-100 border-none text-neutral-400">
                    {/* <th className="py-2 px-4 text-start text-lg">Row</th> */}
                    <th className="py-2 px-4 text-start text-lg">Title</th>
                    <th className="py-2 px-4 text-start text-lg">Date</th>
                    <th className="py-2 px-4 text-start text-lg">Details</th>
                  </tr>
                </thead>
                <tbody>
                  {allReminders.map((reminder) => (
                    <tr key={reminder.id} className="border-gray-200 border">
                      {/* <td className="py-2 px-4"><b>{reminder.reminder_id}</b></td> */}
                      <td key={``} className="py-2 px-4"><b>{reminder.reminder_title}</b></td>
                      <td key={reminder.id} className="py-2 px-4"><b>{reminder.reminder_at}</b></td>
                      <td key={reminder.id} className="py-2 px-4"><b>{reminder.reminder_details}</b></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <button
              onClick={closeModal}
              className="bg-yellow-300 text-black px-4 py-2 rounded hover:bg-yellow-400"
            >
              <b>Close</b>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}